const API_BASE = import.meta.env.VITE_API_BASE
  || import.meta.env.VITE_API_BASE_URL
  || 'https://u5aw5omfkd.execute-api.us-east-2.amazonaws.com/dev'

async function parseError(response) {
  const text = await response.text()

  if (!text) {
    return `Vendor API error: ${response.status}`
  }

  try {
    const payload = JSON.parse(text)
    return payload.error || `Vendor API error: ${response.status}`
  } catch (error) {
    return text
  }
}

export async function searchVendors({ type = 'scope', term }) {
  const normalizedTerm = String(term || '').trim()
  if (!normalizedTerm) {
    return { vendors: [] }
  }

  const url = new URL(`${API_BASE}/vendors/search`)
  url.searchParams.set('type', type)
  url.searchParams.set('term', normalizedTerm)

  const response = await fetch(url.toString())
  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json()
}
